import { running } from "animejs";
import React from "react";
import { useRef } from "react";
import { useEffect } from "react";
import styled from "styled-components";

const Wrap = styled.div`
  position: relative;
  left: 0;
  top: 0;
  width: 1145px;
  height: 115px;
  background: url(${require("@assets/img/game_time_bar.png")}) no-repeat;
`;

const InnerWrap = styled.div`
  position: absolute;
  left: 117px;
  top: 37px;
  width: 1020px;
  height: 48px;
  border-radius: 50px;
  overflow: hidden;
`;

const Inner = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;

  border-radius: 40px;

  &:after {
    content: "";
    position: absolute;
    width: calc(100% - 30px);
    left: 13px;
    top: 4px;
    height: 20px;
    border-radius: 30px;
    background: linear-gradient(rgba(255, 255, 255, 0.6), #ff7e00);
  }
  &.card {
    background-color: #ff7e00;
    &:after {
      background: linear-gradient(rgba(255, 255, 255, 0.6), #ff7e00);
    }
  }
  &.train {
    background-color: #ff0000;
    &:after {
      background: linear-gradient(rgba(255, 255, 255, 0.6), #ff1706);
    }
  }
  &.donut {
    background-color: #ef6d77;
    &:after {
      background: linear-gradient(rgba(255, 255, 255, 0.6), #ef6d77);
    }
  }
`;

const TimeBar = ({ isStart, total, onSuccess, cName }) => {
  const iRef = useRef(null);

  const endFunc = () => {
    onSuccess();
  };

  useEffect(() => {
    //time-bar-move
    const tar = iRef.current;
    if (isStart) {
      tar.addEventListener("animationend", endFunc);
      Object.assign(tar.style, {
        "-webkit-animation": `time-bar-move ${total}s`,
        "-webkit-animation-fill-mode": "forwards",
        "-webkit-animation-play-state": `running`,
        "-webkit-animation-timing-function": "linear",
        animation: `time-bar-move ${total}s`,
        "animation-play-state": `running`,
        "animation-fill-mode": "forwards",
        "animation-timing-function": "linear",
      });
    } else {
      tar.removeEventListener("animationend", endFunc);
      Object.assign(tar.style, {
        "-webkit-animation": `none`,
        "-webkit-animation-play-state": `running`,
        animation: `none`,
        "animation-play-state": `running`,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isStart]);

  useEffect(() => {
    const tar = iRef.current;
    window.__timeBarPause = function (type = true) {
      if (type) {
        tar.classList.add("time-bar-pause");
      } else {
        tar.classList.remove("time-bar-pause");
      }
    };

    return () => {
      tar.removeEventListener("animationend", endFunc);
      window.__timeBarPause = null;
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Wrap>
      <InnerWrap>
        <Inner ref={iRef} className={cName} />
      </InnerWrap>
    </Wrap>
  );
};

export default React.memo(TimeBar);
